import { createSlice } from '@reduxjs/toolkit'

export const refreshSlice = createSlice({
  name: 'refresh',
  initialState: {
    refreshData: false,
  },
  reducers: {
    toggleRefresh: (state) => {
      state.refreshData = !state.refreshData
    },
    resetRefresh: (state) => {
      state.refreshData = false
    },
  },
})

export const { toggleRefresh, resetRefresh } = refreshSlice.actions
export default refreshSlice.reducer
